import type { ReactElement } from 'react';

/**
 * Eyebrow heading for tooltip section labels (e.g. "Variants (3)",
 * "Present (2)"). Shared across the variants / features / diagnoses /
 * orders tooltip bodies.
 */
export function SectionHeading({
  text,
}: {
  readonly text: string;
}): ReactElement {
  return (
    <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
      {text}
    </p>
  );
}
